export const mockOrganisationFiles = [
  {
    url: 'https://staging-static.poweredbypercent.com/organisationimage/staging_organisationimage_6ee1c0b2-d811-4f08-9505-cb378fd54b69.png',
    description: 'Test image 1',
    dimensions: {
      width: 800,
      height: 600,
      aspectRatio: '4:3'
    }
  },
  {
    url: 'https://staging-static.poweredbypercent.com/organisationimage/staging_organisationimage_6ee1c0b2-d811-4f08-9505-cb378fd54b69.png',
    description: 'Test image 2',
    dimensions: {
      width: 1920,
      height: 1080,
      aspectRatio: '16:9'
    }
  }
]
